import { gql } from "@apollo/client";
const CREATE_ADDRESSES = gql`
  mutation createAddress($input: CreateAddressInput!) {
    createAddress(input: $input) {
      __typename
      ... on Address {
        id
        location_id
        street_name
        street_number
        floor
        location {
          name
        }
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const UPDATE_ADDRESS = gql`
  mutation updateAddress($input: UpdateAddressInput!) {
    updateAddress(input: $input) {
      __typename
      ... on Address {
        id
        location_id
        street_name
        street_number
        floor
        location {
          name
        }
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const DELETE_ADDRESS = gql`
  mutation deleteAddress($id: Float!) {
    deleteAddress(id: $id) {
      __typename
      ... on Address {
        id
        location_id
        street_name
        street_number
        floor
        location {
          name
        }
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { CREATE_ADDRESSES, UPDATE_ADDRESS, DELETE_ADDRESS };
